import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/common/common.css'
// 引入svg
import './assets/image/index'

import websocket from './websocket';

Vue.use(ElementUI)

import { DatePicker, ConfigProvider, TreeSelect } from 'ant-design-vue'
Vue.use(DatePicker).use(ConfigProvider).use(TreeSelect)

// 日期格式
import moment from "moment"
Vue.prototype.$moment = moment

Vue.config.productionTip = false
Vue.prototype.$config = config
// 引入中间件
Vue.prototype.$bus = new Vue()

//  引入Echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.$websocket = websocket;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
